var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-layout',[_c('div',{staticClass:"fill-height",staticStyle:{"width":"100%"},attrs:{"fill-height":""}},[_c('m-todo')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }